import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  orders: { id: number; order: number }[];
}

export const useUpdateAddressTypeOrder = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) =>
    axios.post(
      `${env.verifyServiceUrl}individual/address_type/order/`,
      params,
      { headers: { Authorization: authHeader } }
    )
  );
};
